// interfaces
import {
	VendorActionTypes,
	VendorStateTypes,
	IVendorDetails,
    IVendorPagination
} from "./interfaces";

// constants
import { venderTableColumns } from "./constants";

const INIT_STATE = {
    venderTableColumns: venderTableColumns,
	vendorDetails: {},
	vendorList: [],
	loading: false,
	isSuccessVendorList: false,
	isSuccessVendorDetails: false,
	CurrentPage: 1,
	TotalPages: 0,
	TotalItems: 0,
	ItemsPerPage: 20,
};

interface VendorActionType {
	type:
		| VendorActionTypes.API_RESPONSE_SUCCESS
		| VendorActionTypes.API_RESPONSE_ERROR
		| VendorActionTypes.GET_VENDOR_LIST
		| VendorActionTypes.GET_VENDOR_DETAILS
		| VendorActionTypes.RESET;
	payload: {
		actionType?: string;
		data?: any;
		error?: string;
	};
}

const Vendor = (
	state: VendorStateTypes = INIT_STATE,
	action: VendorActionType,
): any => {
	switch (action.type) {
		case VendorActionTypes.API_RESPONSE_SUCCESS:
			switch (action.payload.actionType) {
				case VendorActionTypes.GET_VENDOR_LIST: {
					const {
						CurrentPage = 1,
						TotalPages,
						TotalItems,
						ItemsPerPage,
						Items,
					} = action.payload.data;
					return {
						...state,
						vendorList: Items,
						CurrentPage,
						TotalPages,
						TotalItems,
						ItemsPerPage,
						isSuccessVendorList: true,
						loading: false,
					};
				}
				case VendorActionTypes.GET_VENDOR_DETAILS: {
					return {
						...state,
						isSuccessVendorDetails: true,
						loading: false,
					};
				}
				default:
					return { ...state };
			}
		case VendorActionTypes.API_RESPONSE_ERROR:
			switch (action.payload.actionType) {
				case VendorActionTypes.GET_VENDOR_LIST: {
					return {
						...state,
						vendorListError: action.payload.error,
						isSuccessVendorList: false,
						loading: false,
					};
				}
				case VendorActionTypes.GET_VENDOR_DETAILS: {
					return {
						...state,
						venderDetailsError: action.payload.error,
						isSuccessVendorDetails: false,
						loading: false,
					};
				}
				default:
					return { ...state };
			}
		case VendorActionTypes.GET_VENDOR_LIST:
			return { ...state, loading: true };
		case VendorActionTypes.GET_VENDOR_DETAILS:
			return { ...state, loading: true };
		case VendorActionTypes.RESET:
			return {
				...state,
				loading: false,
				vendorDetails: {},
				vendorList: [],
				isSuccessVendorList: false,
				isSuccessVendorDetails: false,
			};
		default:
			return { ...state };
	}
};

export default Vendor;
